<template>
  <div class="flex grow gap-2">
    <form
      ref="status_form"
      class="space-y-4"
      @submit="submit_without_reloading"
      @reset="
        keyword = undefined;
        path = undefined;
      "
    >
      <div class="space-y-2">
        <div>
          <legend>Tên tệp tin/thư mục</legend>
          <label class="input w-full md:w-fit 2xl:w-fit">
            <i class="fa-solid fa-magnifying-glass text-base-content/80"></i>
            <input
              type="text"
              placeholder="Nhập tên tệp tin/thư mục"
              name="keyword"
              v-model="keyword"
              :disabled="loading.get_files"
            />
          </label>
        </div>
      </div>
      <div class="flex flex-wrap gap-2">
        <input
          class="btn btn-outline grow"
          type="reset"
          value="&#8635; Đặt lại"
          :disabled="loading.get_files"
        />
        <button
          class="btn btn-primary btn-outline grow"
          type="submit"
          :disabled="!filter_has_changed || loading.get_files"
        >
          &#10003; Áp dụng
        </button>
      </div>
    </form>
    <div class="grow overflow-x-auto">
      <div></div>
      <div class="bg-base-100">
        <Loading class="m-auto" v-if="loading.get_files" />
        <table v-else-if="files && files.length > 0" class="table">
          <thead>
            <tr>
              <th>Tên tệp tin/thư mục</th>
              <th>Thời gian chỉnh sửa</th>
              <th>Thời gian quét</th>
              <th>Kích cỡ</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="file in files" :key="file.id">
              <td class="line-clamp-1 space-x-1 truncate">
                <IcoFile v-if="file.type.toLowerCase() === 'file'" />
                <IcoFolder v-if="file.type.toLowerCase() === 'folder'" />
                <span>
                  {{ file.name }}
                </span>
              </td>
              <td>
                <template v-if="file.modified">
                  {{ dayjs.unix(file.modified).format("YYYY/MM/DD HH:mm:ss") }}
                </template>
                <template v-else>
                  <span class="text-base-content/20 italic">
                    Không có thông tin
                  </span>
                </template>
              </td>
              <td>
                <template v-if="file.created">
                  {{
                    dayjs
                      .unix(file.created / 1000)
                      .format("YYYY/MM/DD HH:mm:ss")
                  }}
                </template>
                <template v-else>
                  <span class="text-base-content/20 italic"
                    >Không có thông tin</span
                  >
                </template>
              </td>
              <td>{{ prettyBytes(file.size ?? 0) }}</td>
            </tr>
          </tbody>
        </table>
        <div class="p-2" v-else>
          <NotFound>
            <!-- <template v-slot:action
              >Tạo lệnh quét <button class="link">tại đây</button>.</template
            > -->
          </NotFound>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { number_from_query, str_from_query } from "@/api";
import { axios_instance } from "@/api/api";
import IcoFile from "@/components/IcoFile.vue";
import IcoFolder from "@/components/IcoFolder.vue";
import Loading from "@/components/LoadingTemplate.vue";
import NotFound from "@/components/NotFound.vue";
import { router } from "@/router/router";
import dayjs from "dayjs";
import prettyBytes from "pretty-bytes";
import { computed, onMounted, ref, watch } from "vue";
import { toast } from "vue3-toastify";
import type { client_file } from ".";

const loading = ref({
  get_files: false,
});

const init_keyword = computed(() => str_from_query("keyword"));
const keyword = ref<string | undefined>(str_from_query("keyword"));
const init_path = computed(() => str_from_query("path"));
const path = ref<string | undefined>(str_from_query("path"));
const files = ref<client_file[]>([]);

const filter_has_changed = computed(
  () => keyword.value !== init_keyword.value || path.value !== init_path.value,
);
const submit_without_reloading = (e: Event) => {
  e.preventDefault();
  router.push({
    name: router.currentRoute.value.name,
    query: {
      ...router.currentRoute.value.query,
      page: 1,
      keyword: keyword.value,
      path: path.value,
    },
  });
};

const get_files = async () => {
  const agent_id = router.currentRoute.value.params.client_id;

  if (!agent_id) return;
  const keyword = str_from_query("keyword");
  const path = str_from_query("path");
  const action_id = router.currentRoute.value.params.action_id;
  if (!action_id) return;

  loading.value.get_files = true;
  axios_instance
    .post<{
      data: client_file[] | null;
    }>(`/api/v1/view/explore/pagination`, {
      agent_id: agent_id,
      keyword: keyword,
      path: path,
      action_id: action_id,
      page: number_from_query("page", 1),
      size: number_from_query("size", 24),
    })
    .then((response) => {
      files.value = response.data.data ?? [];
    })
    .catch((err) => toast.error(err))
    .finally(() => (loading.value.get_files = false));
};

watch(
  () => [init_path.value],
  () => {
    path.value = init_path.value;
  },
);

onMounted(() => {
  get_files();
});
</script>
